'use client'

import { useEffect, useState } from 'react'
import {
  LOADING_WATCHDOG_SCRIPT,
  LOADING_WATCHDOG_DELAY_MS,
  LOADING_STUCK_MESSAGE_ID,
  HYDRATED_FLAG,
  startVisibleTimeout,
} from '@/lib/ui/loading-watchdog'

/** 「再読み込みする」を出すまでの待ち（見えている間だけ数える） */
const RETRY_BUTTON_DELAY_MS = 10_000

// HYDRATED_FLAG（'__gforceHydrated'）はインライン script のウォッチドッグと合図する
// 任意プロパティ。Window への型拡張は lib/ui/loading-watchdog.ts（定数と同じ場所）にある。

export default function Loading() {
  // eslint-disable-next-line gforce/route-only-reexport-or-segment-config -- app/loading.tsx は Next.js デフォルト loading UI で useState は GET fallback のみ
  const [showRetry, setShowRetry] = useState(false)

  // commit された＝ハイドレートが生きている。インライン script のウォッチドッグへ知らせ、
  // 発火しても何もしないようにする（正常系の挙動を1ミリも変えないための要）。
  useEffect(() => {
    window[HYDRATED_FLAG] = true
  }, [])

  // 10秒で「再読み込みする」を出し、20秒で自動リロード（ストリーミング途切れ等でスタックした場合の保険）。
  // 🔴 見えている間だけ数える（startVisibleTimeout）。裏のタブ（visibilityState が hidden）では
  //    ブラウザが描画を止めるので、数えると正常な画面でも20秒ごとに読み直してしまう。見えたら数え直す。
  //    https://developer.mozilla.org/en-US/docs/Web/API/Page_Visibility_API
  useEffect(() => startVisibleTimeout(RETRY_BUTTON_DELAY_MS, () => setShowRetry(true)), [])
  useEffect(
    () => startVisibleTimeout(LOADING_WATCHDOG_DELAY_MS, () => window.location.reload()),
    []
  )

  return (
    <div className="min-h-screen flex items-center justify-center bg-surface">
      {/* パース時点で走る保険。commit されない状況（= useEffect が動かない状況）でだけ働く。
          React 19 は script の文字列 children をエスケープせず出力するため、
          埋め込む値は静的リテラルのみ（lib/ui/loading-watchdog.ts 参照）。 */}
      <script>{LOADING_WATCHDOG_SCRIPT}</script>
      <div className="flex flex-col items-center gap-4">
        <div className="h-10 w-10 animate-spin rounded-full border-4 border-[#2563EB] border-t-transparent" />
        <p className="text-sm text-muted-foreground">読み込み中...</p>
        {showRetry && (
          <button
            onClick={() => window.location.reload()}
            className="mt-1 text-xs text-[#2563EB] underline"
          >
            再読み込みする
          </button>
        )}
        <div
          id={LOADING_STUCK_MESSAGE_ID}
          hidden
          className="mt-2 flex flex-col items-center gap-2 text-center"
        >
          <p className="text-sm text-destructive">読み込みに失敗しました</p>
          <button
            onClick={() => window.location.reload()}
            className="text-xs text-[#2563EB] underline"
          >
            再読み込みする
          </button>
        </div>
      </div>
    </div>
  )
}
